import * as React from "react";

export interface IH4Props {
  className?: string;
}

const H4: React.StatelessComponent<IH4Props> = ({ children, className }) => <h4 className={`h4 ${className}`}>{children}</h4>;

export default H4;
